import {merge} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as AccidentIncidentReportActions from 'web-app/react/entities/accident-incident-reports/actions';
import {replayOnTriggerObservable, isActionsArray} from 'web-app/util/epics-helpers';

import * as Actions from './actions';

const listenForUpdates = (action$, state$) =>
    replayOnTriggerObservable(
        action$.ofType(AccidentIncidentReportActions.fetchAllForChild.type),
        action$.ofType(Actions.reset.type),
        merge(action$.ofType(AccidentIncidentReportActions.acknowledgeSuccess.type)),
        replayAction => {
            if (isActionsArray(replayAction)) {
                return state$.value.childProfile.childId === replayAction[0].payload.childId;
            }
            return state$.value.childProfile.childId === replayAction.payload.childId;
        },
    );

export default combineEpics(listenForUpdates);
